export const formatDateToEUFormat = (dateString) => new Date(dateString).toLocaleDateString('uk-Uk');
